<template>
    <v-row>
        <v-col cols="4"></v-col>
        <v-col cols="4" class="text-center">
            <v-chip
                color="#f78da7"
                variant="elevated"
                size="x-large"
                prepend-icon="mdi:mdi-file-document-multiple"
                style="text-align: center; margin-bottom: 8px; color: white"
                elevation="9"
            >
                HR Forms
            </v-chip>
            <v-divider class="border-opacity-25"></v-divider>
        </v-col>
        <v-col cols="4" class="text-end">
            <v-btn
                v-if="can('create hrForm')"
                color="primary"
                @click="showAddFormDialog = !showAddFormDialog"
            >
                <font-awesome-icon icon="fa-solid fa-plus" class="pr-3" />
                Upload Form
            </v-btn>
        </v-col>
    </v-row>
    <v-row>
        <!--                LIST OF FORMS-->
        <v-col cols="5">
            <v-card elevation="11" class="rounded-lg">
                <v-list>
                    <v-list-item
                        v-for="(form, index) in forms"
                        :key="index"
                        :value="form.path"
                        color="primary"
                    >
                        <template v-slot:title>
                            <a class="text-wrap" style="width: 100%; display: block;"
                                :href="`https://connectv2.d3llc.org/storage/${form.storage_path}`"
                                target="_blank"
                            >
                                {{ form.title }}
                            </a>
                                <!-- <div
                                    class="text-wrap"
                                    @click=""
                                >

                                </div> -->
                        </template>
                        <template v-slot:append v-if="can('delete hrForm')">
                            <v-btn
                                color="error"
                                icon="fa-solid fa-trash"
                                size="x-small"
                                @click="deleteForm(form)"
                            >
                            </v-btn>
                        </template>
                        <v-divider></v-divider>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-col>
        <!--                PREVIEW-->
        <!-- <v-col cols="9">
            <div v-show="previewSrc != null" class="fill-height">

            </div>
        </v-col> -->
    </v-row>

    <!---------------------------------------------------------------------------------------------DIALOGS (MODALS)-->
    <v-dialog v-model="showAddFormDialog" max-width="700">
        <v-card title="Add form">
            <v-card-text>
                <form ref="form" @submit.prevent="uploadForm">
                    <v-text-field
                        :rules="[(v) => !!v || 'Item is required']"
                        label="Title"
                        variant="underlined"
                        v-model="newForm.title"
                        color="primary"
                        :error-messages="errors['title']"
                    ></v-text-field>
                    <input
                        type="file"
                        :error-messages="errors['file']"
                        @input="newForm.file = $event.target.files[0]"
                    />
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="showAddFormDialog = false">Close</v-btn>
                        <v-btn variant="elevated" color="primary" type="submit"
                            >Upload
                        </v-btn>
                    </v-card-actions>
                </form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import { useForm } from "@inertiajs/inertia-vue3";

export default {
    setup() {
        const form = useForm({
            title: null,
            file: null,
        });

        return { form };
    },

    data() {
        return {
            forms: this.$page.props.forms,
            previewSrc: null,
            showAddFormDialog: false,
            errors: {
                bool: false
            },
            newForm: {
                title: '',
                file: null
            },
        };
    },
    computed: {
        getPdfUrl(form) {
            let filename = form.storage_path;
            let beginning = window.location.href.replace("/hr/forms", "")
            return `${beginning}/storage/${filename}`;
        },
    },
    methods: {
        // getPdfUrl(form) {
        //     let filename = form.storage_path;
        //     let beginning = window.location.href.replace("/hr/forms", "")
        //     this.previewSrc = `${beginning}/storage/${filename}`
        // },
        deleteForm(form) {
            const formID = form.id;
            axios
                .delete(route("api.delete.form", formID))
                .then((response) => {
                    // if (vueModel.previewSrc === forms[index].path) {
                    //     vueModel.previewSrc = null;
                    // }
                    // forms.splice(index, 1);
                    location.reload();
                })
                .catch(function (response) {
                    // HANDLE ERRORS HERE
                });
        },
        uploadForm() {
            let validationPassed = this.validateForm();
            if (!validationPassed) return;

            const formData = new FormData();
            formData.append('file', this.newForm.file);
            formData.append('title', this.newForm.title.trim());

            axios.post(route("hr.uploadForm"), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then((res) => {
                console.log(res)
                location.reload();
            });
        },
        validateForm() {
            this.errors = {bool: true};
            if (!this.newForm.file) {
                this.errors.file  = ["File is required"]
                this.errors.bool  = false
            }
            if (!this.newForm.title) {
                this.errors.title  = ["Title is required"]
                this.errors.bool  = false
            }

            return this.errors.bool;
        },
        refreshFormList() {
            const vueModel = this;
            axios
                .get(route("api.hr.form"))
                .then((response) => {
                    vueModel.forms = response.data.forms;
                })
                .catch((response) => {
                    // HANDLE ERRORS
                });
        },
    },
};
</script>
<style lang="css" scoped>
.div.text-wrap {
    word-wrap: break-word;
}
</style>
